import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';

function App() {
	
	const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");
	const userType = sessionStorage.getItem("TRCUserType");
	const [clientData, setClientData] = useState('');
	const [clientId, setClientId] = useState(null);
	const [formData, setFormData] = useState({});
	const [dashboardData, setDashboarddata] = useState(false);

	useEffect(() => {
			if(userType && userType === 'admin'){
				window.location = '/admin-dashboard';
			}
		
			if(userType && userType === 'employee'){
				window.location = '/sales-dashboard';
			}
		
			if(userType && userType === 'logistic'){
				window.location = '/logistic-dashboard';
			}
		
		},[]);

	const fetchData = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/dashboard/all-orders/', {userId: userID}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			setDashboarddata(response.data);
		 	console.log(response.data);
		} catch (error) {
		  	console.error(error);
		}
	};
	
	useEffect(() => {
		fetchData();
	}, []); 
	

return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
				<div class="box box-body">
					<div class="row">
						<div class="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-12">
							<div class="box-body rounded-0 p-0 pb-lg-0 pb-sm-15 pb-xs-15 be-1 fill-icon">
								<div class="d-flex align-items-center">
									<div class="w-70 h-70 me-15 bg-primary-light rounded-circle text-center p-10">
										<div class="w-50 h-50 bg-primary rounded-circle">
											<i class="fa fa-shopping-cart fs-24 l-h-50"></i>
										</div>
									</div>
									<div class="d-flex flex-column">
										<span class="text-fade fs-12">Orders</span>
										<h2 class="text-dark hover-primary m-0 fw-600">{dashboardData?.totalOrders}</h2>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-12">
							<div class="box-body rounded-0 p-0 pb-lg-0 pb-sm-15 pb-xs-15 be-1 fill-icon">
								<div class="d-flex align-items-center">
									<div class="w-70 h-70 me-15 bg-info-light rounded-circle text-center p-10">
										<div class="w-50 h-50 bg-info rounded-circle">
											<i class="fa fa-fw fa-bar-chart fs-20 l-h-50"></i>
										</div>		
									</div>
									<div class="d-flex flex-column">
										<span class="text-fade fs-12">Invoices</span>
										<h2 class="text-dark hover-primary m-0 fw-600">{dashboardData?.totalInvoice}</h2>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-12">
							<div class="box-body rounded-0 p-0 pb-lg-0 pb-xs-15 be-1 fill-icon">
								<div class="d-flex align-items-center">
									<div class="w-70 h-70 me-15 bg-danger-light rounded-circle text-center p-10">
										<div class="w-50 h-50 bg-danger rounded-circle">
											<i class="fa fa-user-circle-o fs-20 l-h-50"></i>	
										</div>		
									</div>
									<div class="d-flex flex-column">
										<span class="text-fade fs-12">Dealers</span>
										<h2 class="text-dark hover-primary m-0 fw-600">{dashboardData?.totalDealers}</h2>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-12">
							<div class="box-body rounded-0 p-0 fill-icon">
								<div class="d-flex align-items-center">
									<div class="w-70 h-70 me-15 bg-warning-light rounded-circle text-center p-10">
										<div class="w-50 h-50 bg-warning rounded-circle">
											<i class="fa fa-pie-chart fs-24 l-h-50"></i>
										</div>	
									</div>
									<div class="d-flex flex-column">
										<span class="text-fade fs-12">Today's Sales</span>
										<h2 class="text-dark hover-primary m-0 fw-600">₹{parseFloat(dashboardData?.todayInvoiceAmount).toFixed(2)}</h2>
									</div>
								</div>
							</div>
						</div>	
					</div>
				</div>

				<div class="row">
                    <div class="col-xxxl-12 col-xxl-12 col-xl-12 col-lg-12">
							<div class="box rounded-4">
								<div class="box-header d-flex b-0 justify-content-between align-items-center pb-0">
									<h4 class="box-title">Today's Sales</h4>
									{/* <ul class="m-0" style={{listStyle: 'none'}}>
										<li class="dropdown">
											<button class="waves-effect waves-light btn btn-outline btn-rounded btn-primary btn-sm" href="#"><i class="fa fa-fw fa-arrow-down"> </i> Export</button>
										</li>
									</ul> */}
								</div>
								<div class="box-body pt-0 summery-box">
									<p class="mb-20 text-fade">Today's Sales Summery</p>
									<div class="row">
										<div class="col-lg-3 col-md-6">
	                                        <div class="box pull-up mb-sm-0 bg-danger-light">
	                                          	<div class="box-body ">
		                                            <div class="w-50 h-50 bg-danger rounded-circle text-center "> 
		                                                <i class="fa fa-area-chart fs-18 l-h-50"></i>
		                                            </div>
		                                            <h2	 class="fw-600 mt-3">{dashboardData?.todayOrders}</h2	>
		                                            <p class="text-fade fw-500 mb-2">New Orders</p>
	                                          	</div>
	                                        </div>
	                                    </div>
	                                    <div class="col-lg-3 col-md-6">
	                                        <div class="box pull-up mb-sm-0 bg-warning-light">
	                                          	<div class="box-body ">
		                                            <div class="w-50 h-50 bg-warning rounded-circle text-center"> 
		                                                <i class="fa fa-file fs-18 l-h-50"></i>
		                                            </div>
		                                            <h2	 class="fw-600 mt-3">{dashboardData?.todayInvoices}</h2	>
		                                            <p class="text-fade fw-500 mb-2">New Invoices</p>
	                                          	</div>
	                                        </div>
	                                    </div>
	                                    <div class="col-lg-3 col-md-6">
	                                        <div class="box pull-up mb-0 bg-info-light">
	                                          	<div class="box-body ">
		                                            <div class="w-50 h-50 bg-info rounded-circle text-center"> 
		                                                <i class="fa fa-tag fs-18 l-h-50"></i>
		                                            </div>
		                                            <h2	 class="fw-600 mt-3">₹{parseFloat(dashboardData?.todayOrderAmount).toFixed(2)}</h2	>
		                                            <p class="text-fade fw-500 mb-2">Order Value</p>
	                                          	</div>
	                                        </div>
	                                    </div>
	                                    <div class="col-lg-3 col-md-6">
	                                        <div class="box pull-up mb-0 bg-danger-light">
	                                          	<div class="box-body ">
		                                            <div class="w-50 h-50 bg-danger rounded-circle text-center"> 
		                                                <i class="fa fa-user fs-20 l-h-50"></i>
		                                            </div>
		                                            <h2	 class="fw-600 mt-3">{parseFloat(dashboardData?.todayOrders) - parseFloat(dashboardData?.todayInvoices)}</h2	>
		                                            <p class="text-fade fw-500 mb-2">Pending Invoices</p>
	                                          	</div>
	                                        </div>
	                                    </div>
									</div>
								</div>
							</div>
						</div>

                        <div class="col-xxl-6 col-xl-6 col-lg-6">
							<div class="card rounded-4">
								<div class="box-header d-flex b-0 justify-content-between align-items-center">
									<h4 class="box-title">New Orders</h4>
								</div>
								<div class="card-body pt-0">
									<div class="table-responsive">
										<table class="table mb-0">
											<tbody>
											{dashboardData?.orderList?.map((orders, index) => 
		                                        <tr key={index}>
		                                          <td class="pt-0 px-0 b-0 w-50">
		                                          	<img class="img-fluid img-40 rounded-circle w-40 h-40 bg-light p-1" src="assets/images/avatar/avatar-1.png" alt="user" />
		                                          </td>
												  <td>{index+1}</td>
												  <td class="pt-0 px-0 b-0"><a class="d-block fw-500 fs-14" href={`/order-details?id=${orders.orderId}`}>{orders.orderId}</a><span class="text-light">₹{parseFloat(orders.totalPayment).toFixed(2)}</span></td>
												  <td class="text-end b-0 pt-0 px-0">
		                                            <a href={`/order-details?id=${orders.orderId}`} class="waves-effect waves-light">{ orders.status === 'delivered' ? 'Delivered': orders?.dealer?.name +' - '+ orders?.dealer?.route}</a>
		                                          </td>
		                                        </tr>
											)}
											{dashboardData?.orderList?.length <= 0 && 
											<tr>
												<td colspan="3">
													No Oders Placed
												</td>
											</tr>
											}
		                                    </tbody>
										</table>
									</div>
								</div>	
							</div>
						</div>
						<div class="col-xxl-6 col-xl-6 col-lg-6">
							<div class="card rounded-4">
								<div class="box-header d-flex b-0 justify-content-between align-items-center">
									<h4 class="box-title">New Invoices</h4>
								</div>
								<div class="card-body pt-0">
									<div class="table-responsive">
										<table class="table mb-0">
											<tbody>
											{dashboardData?.invoiceList?.length <= 0 ?
											<tr>
												<td colspan="3">
													No Deliveries for today
												</td>
											</tr>
											:
											dashboardData?.invoiceList?.map((orders, index) => 
		                                        <tr key={index}>
		                                          <td class="pt-0 px-0 b-0 w-50">
		                                          	<img class="img-fluid img-40 rounded-circle w-40 h-40 bg-light p-1" src="assets/images/avatar/avatar-1.png" alt="user" />
		                                          </td>
		                                          <td>{index+1}</td>
												  <td class="pt-0 px-0 b-0"><a class="d-block fw-500 fs-14" href={`/invoice-details?id=${orders?.orderId}`}>TRC/{orders?.invoiceNo}</a><span class="text-light">₹{parseFloat(orders.totalPayment).toFixed(2)}</span></td>
												  <td class="text-end b-0 pt-0 px-0">
		                                            <a href={`/invoice-details?id=${orders?.orderId}`} class="waves-effect waves-light">{ orders?.status === 'delivered' ? 'Delivered' : orders?.dealer?.name +' - '+ orders?.dealer?.route}</a>
		                                          </td>
		                                        </tr>
											)}
											
		                                    </tbody>
										</table>
									</div>
								</div>	
							</div>
						</div>
						
						
						

					</div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default App;